export default __webpack_public_path__ + "static/media/UploadVideoFile.8d6088ca.svg";